module.exports = __webpack_public_path__ + "images/featureImage.ed0c5514.webp";